<template>
  <v-flex sm12>
    <v-container fluid pt-5 pb-5 mt-5 style="height: 80vh">
      <v-flex style="height: 80vh">
        <v-card md12 class="mb-5 elevation-0" style="height: 80vh">
          <v-tabs centered color="#D5D5D5" show-arrows dark v-model="tab" class="rounded-tabs">
            <v-toolbar-title class="title">
              <div class="display-1 mt-3 mr-5 tamany_titol tw-txt-color-primary">{{ 'documentation.title' | t }}</div>
            </v-toolbar-title>
            <v-tabs-slider color="primary ratlla"></v-tabs-slider>

            <v-tab v-if="getConsumer('digital')" href="#tab-1" class="text_tab clear_full separa_tab">
              {{ 'playground.title_digital' | t }}
            </v-tab>
            <v-tab v-if="getConsumer('youtube')" href="#tab-2" class="text_tab clear_full separa_tab">
              {{ 'playground.title_youtube' | t }}
            </v-tab>
            <v-tab v-if="getConsumer('law')" href="#tab-3" class="text_tab clear_full separa_tab">
              {{ 'playground.title_law' | t }}
            </v-tab>
            <v-tab v-if="getConsumer('instagram')" href="#tab-4" class="text_tab clear_full separa_tab">
              {{ 'playground.title_instagram' | t }}
            </v-tab>
            <v-tab v-if="getConsumer('facebook')" href="#tab-5" class="text_tab clear_full separa_tab">
              {{ 'playground.title_facebook' | t }}
            </v-tab>
            <v-tab v-if="getConsumer('twitter')" href="#tab-6" class="text_tab clear_full separa_tab"> {{ 'playground.title_twitter' | t }} X </v-tab>

            <v-tab-item value="tab-1" style="height: 80vh">
              <documentation type="digital" />
            </v-tab-item>
            <v-tab-item value="tab-2" style="height: 80vh">
              <documentation type="youtube" />
            </v-tab-item>
            <v-tab-item value="tab-3" style="height: 80vh">
              <documentation type="law" />
            </v-tab-item>
            <v-tab-item value="tab-4" style="height: 80vh">
              <documentation type="instagram" />
            </v-tab-item>
            <v-tab-item value="tab-5" style="height: 80vh">
              <documentation type="facebook" />
            </v-tab-item>
            <v-tab-item value="tab-6" style="height: 80vh">
              <documentation type="twitter" />
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-flex>
      <faqs></faqs>
    </v-container>
  </v-flex>
</template>

<script>
import Documentation from '@/components/Documentation'
import { mapGetters, mapActions } from 'vuex'
import Faqs from '@/components/Faqs'

export default {
  data() {
    return {
      tab: 'digital'
    }
  },
  components: {
    Documentation,
    Faqs
  },
  computed: {
    ...mapGetters(['getConsumer', 'getUserId', 'getServer', 'getTokenHeader'])
  },
  methods: {
    ...mapActions(['setMyConsumers', 'rmKey'])
  },
  created() {
    // if (this.$route.query.tab) this.tab = this.$route.query.tab;
    const userid = this.user ? parseInt(this.user, 0) : this.getUserId
    this.$http.get(`${this.getServer}/users/${userid}/consumers`, this.getTokenHeader).then(data => {
      if (data.data) {
        this.setMyConsumers(data.data)
        this.formload = false
      }
    })
  }
}
</script>

<style scoped>
.rounded-tabs {
  border-radius: 6px !important;
}
.rounded-tabs-sub {
  border-radius: 6px !important;
}
.tamany_titol {
  font-size: 28px !important;
  font-weight: 400;
  line-height: 20px !important;
  letter-spacing: normal !important;
  font-family: 'Roboto', sans-serif !important;
}
.tamany_titol_sitebar {
  font-size: 18px !important;
  font-weight: 400;
  line-height: 20px !important;
  letter-spacing: normal !important;
  font-family: 'Roboto', sans-serif !important;
}

.subtitol {
  padding-top: 8px !important;
  padding-left: 20px !important;
  background-color: #f2f2f2 !important;
  padding-bottom: 6px !important;
}
.ratlla {
  height: 5px !important;
}
.separa_tab_init_pg {
  position: static !important;
  margin-right: 120px !important;
}
.separa_tab {
  /*padding: 6px 20px !important;*/
  position: static !important;
  margin-left: 10px !important;
  margin-right: 10px !important;
}
.clear_full {
  text-transform: none !important;
}
.text_tab {
  font-size: 20px !important;
}
.color_digital {
  color: #80d484 !important;
}
.color_youtube {
  color: #e62117 !important;
}
.color_instagram {
  color: #ca41e2 !important;
}
.color_facebook {
  color: #4267b2 !important;
}
.color_twitter {
  color: rgb(8, 245, 253) !important;
}
.color_law {
  color: #e4d341 !important;
}
.color_newspro {
  color: #476b63 !important;
}
.nopadding {
  padding: 0px !important;
  padding-top: 16 !important;
}
.background {
  /*background-color: rgb(241 85 80 / 15%) !important;*/
  background: linear-gradient(to bottom, rgb(241 85 80 / 15%), #ffffff) !important; /* De rojo a blanco */
}
.tw-txt-color-primary {
  /*color: #00ff37 !important;*/
  color: #515151 !important;
}
</style>
